export default {
  FORCED_STAGE_COOLING_QUANTITY: 0,
  INFORMED_MAXIMUM_POINTS_LIMIT: 1500,
  SIMULATION_MAXIMUM_POINTS_LIMIT: 21000,
  TIME_INTERVAL_BETWEEN_POINTS: 15,
  SIMULATION_REPETITIONS_NUMBER: 0,
  WINDING_TIME_CONSTANT: 300,
  CHECK_RESULT_STATUS_INTERVAL: 5000,
};
